export const REQUEST_PROCESS_STEP_STATES = {
    IDLE: 'IDLE',
    FETCH_EVENT_SETTINGS: 'FETCH_EVENT_SETTINGS',
    AUTHENTICATE: 'AUTHENTICATE',
};

/**
 * This hook is used to know which is the request that should be triggered given the data in the VEP tokens.
 *
 * @param {Object{ vepTokens, setVepTokens }} props - A props list with the current VEP tokens.
 * @return {string} - The flow that should be triggered.
 */
const useGetRequestFlowStep = ({ vepTokens, enabled }) => {
    const shouldFetchEventSettings = Boolean(vepTokens?.guestAccessHash && enabled);

    if (shouldFetchEventSettings) {
        return REQUEST_PROCESS_STEP_STATES.FETCH_EVENT_SETTINGS;
    } else {
        return REQUEST_PROCESS_STEP_STATES.IDLE;
    }
};

export default useGetRequestFlowStep;
